__turbopack_context__.v({
  "disabled": "BaseStyleTextField-module-scss-module__ZBKqpW__disabled",
  "error": "BaseStyleTextField-module-scss-module__ZBKqpW__error",
  "input": "BaseStyleTextField-module-scss-module__ZBKqpW__input",
  "security": "BaseStyleTextField-module-scss-module__ZBKqpW__security",
  "wrapper": "BaseStyleTextField-module-scss-module__ZBKqpW__wrapper",
});
